<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-courses modal-no-padding" style="width: max-content">
    <div class="modal-no-padding__header">
      <h2>История обучения</h2>
    </div>
    <a-divider style="margin: 16px 0" />

    <div class="modal-no-padding__body">
      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="detailedActivity"
          :scroll="{ x: 800 }"
          :pagination="false"
          :loading="tableLoading"
          :table-layout="'fixed'"
          class="modal-courses-table"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'status'">
            <a-tag color="green" v-if="record.original_status === 'finished'">
              Завершен
            </a-tag>
            <a-tag class="yellow-tag" v-else-if="record.original_status === 'new'">
              Не начат
            </a-tag>
            <a-tag v-else-if="record.is_expired" class="red-tag">
              В процессе
            </a-tag>
            <a-tag  v-else class="blue-tag">
              В процессе
            </a-tag>
          </template>
        </template>

        <template #emptyText>
          <div class="no-data-wrapper">
            <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>
            <div class="no-data-text">
              Нет данных для отображения. Для назначения курсов обратитесь к руководителю.
            </div>
          </div>
        </template>
      </a-table>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
            <a-button class="secondary-button" @click="closeForm">Закрыть</a-button>
            <a-button class="secondary-button" @click="goToUserActivity">Смотреть всю историю</a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>
<script>

import {useRouter} from "vue-router";
import {DownOutlined, PlusOutlined} from "@ant-design/icons-vue";
import {computed} from "@vue/reactivity";
import {onBeforeMount, ref} from "@vue/runtime-core";
import {useStore} from "vuex";
import {getCourseStatus} from "@/feature/group-control/utils/coursePassingUtils";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";

export default {
  components: {PlusOutlined, DownOutlined},
  props: {
    open: Boolean,
    courses: Array,
    email: String,
  },
  emits: ['close'],
  setup(props, context) {
    const router = useRouter();

    const columns = computed(() => [
      {
        title: 'Событие',
        dataIndex: 'name',
        sorter: false,
        width: 250,
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        sorter: false,
        width: 90,
      },
      {
        title: 'Дата назначения',
        dataIndex: 'started_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Дата завершения',
        dataIndex: 'finished_at',
        sorter: false,
        width: 120,
      },
    ]);

    const tableLoading = ref(true);
    const store = useStore();
    const detailedActivity = ref([]);

    const closeForm = () => {
      context.emit('close');
    }

    onBeforeMount(() => {
      tableLoading.value = true;
      detailedActivity.value = props.courses.slice(0, 5).map((el) => {
        return {
          name: el.name,
          code: el.code ?? null,
          status: getCourseStatus(el),
          original_status: el.status,
          started_at: el.activated_at ? el.activated_at : el.activated_at,
          finished_at: el.finished_at ?? null,
          is_expired: el.is_expired ?? null,
        }
      });
      tableLoading.value = false;
    });

    const goToUserActivity = () => {
      if (props.email) {
        store.dispatch('users/setUserFilters', {
          filters: {
            name: '',
            job_title: '',
            department: '',
            online_from: '',
            created_at: '',
            email: props.email ?? '',
            telephone: '',
            groups: [],
            without_group_only: false,
            without_limits_only: false,
            level_from: null,
            level_to: null,
          },
          filterString: `Почта: ${props.email ?? ''}`,
        });
      }

      router.push('/courses');
    }

    return {
      closeForm,
      router,
      columns,
      tableLoading,
      detailedActivity,
      NotFoundIcon,
      goToUserActivity
    }
  }
}
</script>

<style scoped lang="scss">
.tests-list {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .secondary-button {
    margin-top: 16px;
  }
}

.test-details-card-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    justify-content: center;
  }
}

.test-title {
  font-weight: 600;
}

.test-image-wrapper img {
  width: 100px;
  max-height: 140px;
  object-fit: cover;
}

.action-buttons {
  justify-content: flex-end;
  display: flex;
  gap: 8px;

  @media(max-width: $mobile-breakpoint) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
}

.modal-courses {
  min-width: 600px;
  font-size: 14px;
}

.modal-courses-table {
  :deep(.ant-table-thead>tr>th) {
    padding: 5px 10px !important;
  }
}

:deep(.ant-modal-footer .secondary-button) {
  margin-inline-start: 0 !important;
}

h2 {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
}
</style>
